/**
 * @fileoverview Pill component React interface.
 * @author Lisa Liu (lliu@yext.com)
 */
goog.declareModuleId('yext.ui.components.Pill');

import {classNames} from '/ui/lib/classnames';
import {Clickable} from '/ui/components/clickable/clickable';

const elemRoot = 'yext-pill';
const pillRoot = `${elemRoot}__pill`;

/**
 * @param {{children?: React.ReactNode,
 *          text: string,
 *          tid?: string,
 *          type: string,
 *          onRemove?: Function,
 *        }} props
 * @returns {React.ReactElement}
 */
export function Pill({
  children,
  text,
  tid,
  type,
  onRemove,
}) {
  const pillClasses = classNames(
    `${pillRoot}`,
    `${pillRoot}--${type}`,
  );

  const onRemoveTrigger = (!!onRemove && type === 'user')
    ? <Clickable tag="span" aria-label={`Remove pill with text: ${text}.`} className={`${elemRoot}__remove-trigger`} onClick={onRemove} />
    : null;

  return (
    <span className={pillClasses} tid={tid}>
      {children && children}
      <span className={`${pillRoot}-text`}>{text}</span>
      {onRemoveTrigger}
    </span>
  );
}
